import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Meta, Title, SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SpotPageDetails } from 'src/app/interfaces/common/spot.interface';

@Component({
  selector: 'app-spot',
  templateUrl: './spot.component.html',
  styleUrls: ['./spot.component.scss'],
})
export class SpotComponent implements OnInit, OnDestroy {
  id!: string;
  type!: string;
  route!: string;
  filteredData!: SpotPageDetails | undefined;
  subRouteOne!: Subscription;

  public structuredData!: SafeHtml;

  // TODO: Add an proper interface and move this to some kind of file or load it from backend
  metaData: { [key: string]: any } = {
    aalborg: {
      escort: {
        title: 'Escort Aalborg - Myescort.dk',
        description:
          'Søger du escort i Aalborg? Hos os finder du escort, massage og mange flere escort annoncer. Nye frække escort annoncer i Aalborg hver dag.',
      },
      massage: {
        title: 'Massage i Aalborg - Find din massage med myescort.dk',
        description:
          'Find diskrete massage i Aalborg på myescort.dk. Vælg mellem erfarne escorts til en luksuriøs og privat oplevelse, der er skræddersyet til dine behov.',
      },
    } as any,
    odense: {
      escort: {
        title: 'Escort Odense - Opdag din ideelle ledsager på myescort.dk',
        description:
          'Søger du escort i Odense? Hos os finder du escort, massage, dominas og mange flere sex annoncer. Nye frække annoncer i Odense hver dag.',
      },
      massage: {
        title: 'Massage Odense - Læs vores escortguide',
        description:
          'Oplev eksklusive massage-escorttjenester i Odense på myescort.dk. Vores professionelle escorts står klar til at forkæle dig i en tryg og diskret atmosfære.',
      },
    },
    koebenhavn: {
      escort: {
        title: 'Escort i København - Find din ledsager på myescort.dk',
        description:
          'Escort København – find diskrete og professionelle escorts på myescort.dk. Få en skræddersyet, luksuriøs oplevelse med fokus på dine ønsker og fuld diskretion.',
      },
      massage: {
        title: 'Massage i København - Læs vores escortguide & sex annoncer',
        description:
          'Nyd førsteklasses massage-escortannoncer i København på myescort.dk. Vores udvalgte escorts tilbyder elegante, private møder med fokus på diskretion og velvære.',
      },
    },
    aarhus: {
      escort: {
        title: 'Escort Aarhus - Find escort piger med myescort.dk',
        description:
          'Find de nyeste sexannoncer, massage og professionelle escort piger i Aarhus på myescort.dk. Book en diskret og eksklusiv oplevelse i dag.',
      },
      massage: {
        title: 'Massage i Aarhus - Find din massage med myescort.dk',
        description:
          'Udforsk unikke massage-escorttilbud i Aarhus på myescort.dk. Vælg mellem erfarne escorts, der leverer personlig, intim service i en afslappet og diskret ramme.',
      },
    },
    valby: {
      escort: {
        title: 'Find Escort i Valby med myescort.dk',
        description:
          'Find escort i Valby - din guide til escort i Valby. Gennemse diskrete sex annoncer og book trygt via sikre platforme som myescort.dk',
      },
    },
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private meta: Meta,
    private title: Title,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.subRouteOne = this.activatedRoute.paramMap.subscribe(() => {
      this.initializeRoute();
    });

    this.route = this.router.url.substring(1);
    const urlSegments = this.route.split('-');
    if (urlSegments.length > 1) {
      this.type = urlSegments[0];
      this.id = urlSegments[1].split('?')[0];
      const advertJsonLd = {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: this.metaData[this.id][this.type].title,
        url: this.router.url,
        description: this.metaData[this.id][this.type].description,
        itemListOrder: 'https://schema.org/ItemListOrderDescending',
      };

      this.structuredData = this.sanitizer.bypassSecurityTrustHtml(
        `<script type="application/ld+json">${JSON.stringify(advertJsonLd)}</script>`
      );
    }
  }

  private initializeRoute(): void {
    this.route = this.router.url.substring(1);
    const urlSegments = this.route.split('-');

    if (urlSegments.length > 1) {
      this.type = urlSegments[0];
      this.id = urlSegments[1].split('?')[0];
      // Handle errors
      if (this.metaData[this.id][this.type] === undefined) {
        console.log('Missing metadata', this.id, this.type);
      }
      // Set meta tags
      this.meta.updateTag({
        name: 'title',
        content: this.metaData[this.id][this.type].title,
      });
      this.meta.updateTag({
        name: 'description',
        content: this.metaData[this.id][this.type].description,
      });
      this.meta.updateTag({
        name: 'og:title',
        content: this.metaData[this.id][this.type].title,
      });
      this.meta.updateTag({
        name: 'og:description',
        content: this.metaData[this.id][this.type].description,
      });
      this.title.setTitle(this.metaData[this.id][this.type].title);

      this.filteredData = this.data.find(item => {
        return (
          item.spot.toLowerCase() === this.id && item.service === this.type
        );
      });
      this.cdr.detectChanges();
      if (!this.filteredData) {
        this.router.navigate(['/404']);
      }
    } else {
      this.router.navigate(['/404']);
    }
  }
  ngOnDestroy(): void {
    if (this.subRouteOne) {
      this.subRouteOne.unsubscribe();
    }
  }
  data: SpotPageDetails[] = [
    {
      spot: 'Aalborg',
      spotType: 'zone',
      service: 'escort',
      pageTitle: 'Escort Aalborg',
      heading: 'Her finder du de nyeste og bedste escort annoncer i Aalborg',
      firstPara:
        'Er du på udkig efter escort annoncer i Aalborg? Her finder du listen over alle escort, massage, BDSM og trans annoncer i Aalborg og Nordjylland. Hvis du søger efter escort annoncer i andre dele af Danmark,',
      secondPara: 'Hvis du vil bruge filter,',
      thirdPara:
        'Ønsker du at oprette en profil på Myescort.dk eller oprette en annonce,',
    },
    {
      spot: 'Aalborg',
      spotType: 'zone',
      service: 'massage',
      pageTitle: 'Massage Aalborg',
      heading: 'Søger du massage i Aalborg? Se massage annoncer her:',
      firstPara:
        'Er du på udkig efter massage annoncer i Aalborg? Her finder du listen over alle escort, massage, BDSM og trans annoncer i Aalborg og Nordjylland. Hvis du søger efter massage annoncer i andre dele af Danmark,',
      secondPara: 'Hvis du vil bruge filter,',
      thirdPara:
        'Ønsker du at oprette en profil på Myescort.dk eller oprette en annonce,',
    },
    {
      spot: 'Aarhus',
      spotType: 'zone',
      service: 'escort',
      pageTitle: 'Escort Aarhus',
      heading: 'Se de nyeste escort og massage annoncer i Aarhus her:',
      firstPara:
        'Her finder du alle escort & sex annoncer i nærheden af Aarhus. I Aarhus kan du finde mange escort piger, sex annoncer fra både kvinder og mænd, BDSM dominas annoncer og mangle andre. Hvis du vil bruge filter,',
      secondPara: 'Søger du escort i andre dele af Danmark,',
      thirdPara: 'Ønsker du at oprette en annonce, så',
    },
    {
      spot: 'Aarhus',
      spotType: 'zone',
      service: 'massage',
      pageTitle: 'Massage Aarhus',
      heading: 'Har du brug for massage i Aarhus?',
      firstPara:
        'Hos Myescort.dk finder du bedste erotiske massage i Odense og på Fyn. Vi har altid nye massage, escort og sex annoncer klar til dig. Brug søgefunktionen, hvis du søger andre former for escort eller massage.',
      secondPara: 'Hvis du vil bruge filter,',
      thirdPara:
        'Ønsker du at oprette en profil på Myescort.dk eller oprette en annonce,',
    },
    {
      spot: 'Valby',
      spotType: 'zone',
      service: 'escort',
      pageTitle: 'Escort Valby',
      heading: 'Se de nyeste escort og massage annoncer i Valby her:',
      firstPara:
        'Her finder du alle escort & sex annoncer i Valby. I Valby kan du finde mange escort piger, sex annoncer fra både kvinder og mænd, BDSM dominas annoncer og mangle andre. Hvis du vil bruge filter,',
      secondPara: 'Søger du escort i andre dele af Danmark,',
      thirdPara: 'Ønsker du at oprette en annonce, så',
    },
    {
      spot: 'Valby',
      spotType: 'zone',
      service: 'massage',
      pageTitle: 'Massage Valby',
      heading: 'Massage annoncer i Valby',
      firstPara:
        'Hos Myescort.dk finder du bedste erotiske massage i Odense og på Fyn. Vi har altid nye massage, escort og sex annoncer klar til dig. Brug søgefunktionen, hvis du søger andre former for escort eller massage.',
      secondPara: 'Hvis du vil bruge filter,',
      thirdPara:
        'Ønsker du at oprette en profil på Myescort.dk eller oprette en annonce,',
    },
    {
      spot: 'Koebenhavn',
      spotType: 'zone',
      service: 'escort',
      pageTitle: 'Escort København',
      heading: 'Søger du massage i København? Se massage annoncer her:',
      firstPara:
        'Er du på udkig efter massage annoncer i København? Her finder du listen over alle escort, massage, BDSM og trans annoncer i København. Hvis du søger efter massage annoncer i andre dele af Danmark,',
      secondPara: 'Hvis du vil bruge filter,',
      thirdPara:
        'Ønsker du at oprette en profil på Myescort.dk eller oprette en annonce,',
    },
    {
      spot: 'Koebenhavn',
      spotType: 'zone',
      service: 'massage',
      pageTitle: 'Massage København',
      heading: 'Massage annoncer i København',
      firstPara:
        'Hos Myescort.dk finder du bedste erotiske massage i Odense og på Fyn. Vi har altid nye massage, escort og sex annoncer klar til dig. Brug søgefunktionen, hvis du søger andre former for escort eller massage.',
      secondPara: 'Hvis du vil bruge filter,',
      thirdPara:
        'Ønsker du at oprette en profil på Myescort.dk eller oprette en annonce,',
    },
    {
      spot: 'Odense',
      spotType: 'area',
      service: 'escort',
      pageTitle: 'Escort Odense',
      heading: 'Nyeste escort, sex og massage annoncer i Odense og Fyn',
      firstPara:
        'Her finder du de nyeste escort, sex og massage annoncer i Odense og på Fyn på Myescort.dk. Escort i Odense er kendt for mange BDSM annoncer samt gode thaimassør. Du kan også finde annoncer fra mænd og private sex annoncer. Hvis du vil bruge filter,',
      secondPara: 'Ønsker du at oprette en annonce,',
      thirdPara: 'Se escort og andre annoncer i andre dele af Danmark',
    },
    {
      spot: 'Odense',
      spotType: 'area',
      service: 'massage',
      pageTitle: 'Massage Odense',
      heading: 'Find de bedste massage og escort annoncer i Odense',
      firstPara:
        'Hos Myescort.dk finder du bedste erotiske massage i Odense og på Fyn. Vi har altid nye massage, escort og sex annoncer klar til dig. Brug søgefunktionen, hvis du søger andre former for escort eller massage.',
      secondPara: 'Hvis du vil bruge filter,',
      thirdPara:
        'Ønsker du at oprette en profil på Myescort.dk eller oprette en annonce,',
    },
  ];
}
